module.exports = __webpack_public_path__ + "img/parliament-6.435cccb2.jpg";